/**
 * Dollar formatting, in the two forms this app needs.
 *
 * Both existed already, four times over, and twice under the name
 * `formatMoney` with different behaviour -- which is how the Offers page came
 * to round a $100.47 cash-back figure up to $101. The names here say which
 * form you are getting.
 */

/**
 * The minus goes before the dollar sign: "-$8", never "$-8". Decided on the
 * rounded figure, so a value that rounds to zero does not print "-$0".
 * (2026-09-11: Citi's negative balance rendered "$-8".)
 */
function withSign(n: number, body: string): string {
  return `${n < 0 && /[1-9]/.test(body) ? "-" : ""}$${body}`;
}

/** Whole dollars, grouped. Mirrors the views' `:,.0f`. */
export function formatWhole(n: number): string {
  return withSign(n, Math.abs(Math.round(n)).toLocaleString("en-US"));
}

/** To the cent. Mirrors the views' `:,.2f`, for figures rounding would lie about. */
export function formatExact(n: number): string {
  return withSign(
    n,
    Math.abs(n).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  );
}
